import React from "react";

export const AlertErrorMaxFileSizePrestamos = () => (
    <div className="toast-error-max-file-size">
        <p>Solo son válidos archivos pdf de máximo 8MB.</p>
        <p>Le recomendamos comprimir el archivo en la siguiente página web: <a href="https://www.compress2go.com/es" target="_blank" className="toast-error-custom-link">Link</a></p>
    </div>
);
